import { useEffect } from 'react';

import { IChecklistTask } from '@features/Checklist/model/types';
import { syncChecklistBadge } from '@features/Checklist/lib/helpers/syncChecklistBadge';

interface IUseSyncChecklistBadgeParams {
    positionGuid: string;
    checklist: IChecklistTask[] | null;
    labelPrefix: string;
}

export const useSyncChecklistBadge = ({
    positionGuid,
    checklist,
    labelPrefix,
}: IUseSyncChecklistBadgeParams) => {
    useEffect(() => {
        syncChecklistBadge({
            positionGuid,
            checklist,
            labelPrefix,
        });
    }, [checklist, labelPrefix, positionGuid]);
};
